import React from "react";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { setEndDate } from "./HealthMonitoringUtils/setEndDate";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useAppStore } from "../../../appStore";
import { enUS, enGB } from "date-fns/locale";

export const EndDateDropDownHM = ({
  userFilters,
  setUserFilters,
}: {
  userFilters: any;
  setUserFilters: Dispatcher<any>;
}) => {
  const [endTimeAnchorEl, setEndTimeAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const endTimeOpen = Boolean(endTimeAnchorEl);
  const handleEndTimeClick = (event: React.MouseEvent<HTMLElement>) => {
    setEndTimeAnchorEl(event.currentTarget);
  };
  const handleEndTimeClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setEndTimeAnchorEl(null);
  };

  const { dateMMDDYYYY, setDateMMDDYYYY } = useAppStore();

  const selectedLocale = dateMMDDYYYY ? enUS : enGB;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={selectedLocale}
    >
      <DatePicker
        label={
          userFilters.end_date ? (
            <div className="flex">
              <>End Date</>
              <div>
                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-controls={endTimeOpen ? "long-menu" : undefined}
                  aria-expanded={endTimeOpen ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleEndTimeClick}
                  sx={{
                    marginLeft: "5px",
                    padding: 0,
                    color: "#000000",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    "aria-labelledby": "long-button",
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  anchorEl={endTimeAnchorEl}
                  open={endTimeOpen}
                  onClose={handleEndTimeClose}
                  slotProps={{
                    paper: {
                      style: {
                        maxHeight: 48 * 4.5,
                        width: "20ch",
                      },
                    },
                  }}
                >
                  <MenuItem
                    key="mm-dd-yyyy-end"
                    onClick={(event) => {
                      setDateMMDDYYYY(true);
                      handleEndTimeClose(event);
                    }}
                  >
                    MM/DD/YYYY
                  </MenuItem>
                  <MenuItem
                    key="dd-mm-yyyy-end"
                    onClick={(event) => {
                      setDateMMDDYYYY(false);
                      handleEndTimeClose(event);
                    }}
                  >
                    DD/MM/YYYY
                  </MenuItem>
                </Menu>
              </div>
            </div>
          ) : (
            <>End Date</>
          )
        }
        value={userFilters.end_date}
        onChange={(newValue) => {
          if (newValue !== null) {
            setEndDate(newValue, userFilters, setUserFilters);
          }
        }}
        renderInput={(params) => <TextField sx={{ width: 150 }} {...params} />}
      />
    </LocalizationProvider>
  );
};
